module.exports = new __parcel__URL__("meteo_previ.3ade7218.svg").toString();